// extracted by mini-css-extract-plugin
export default {"title-img-block":"SNjMw","title-img-block-image":"nVqYR","title-block-title":"pTZst","title-description":"ySL1E"};